import { List, CreateButton, TopToolbar } from 'react-admin';
import { Box } from '@mui/material';
import AttributeCards from './AttributeCards';

const Actions = () => (
  <TopToolbar>
    <CreateButton label="תכונה חדשה" />
  </TopToolbar>
);

const AttributeList = () => (
  <List className="crm-mobile-list"
    resource="attributes"
    pagination={false}
    perPage={1000}
    storeKey={false}
    actions={<Actions />}
    title="תכונות"
    sx={{ '& .RaList-content': { boxShadow: 'none', backgroundColor: 'transparent' } }}
  >
    <Box sx={{ width: '100%' }}>
      <AttributeCards />
    </Box>
  </List>
);

export default AttributeList;
